export const filter = {
	user_id: null,
	begin_date: '',
	end_date: '',
	checkedModules: ['client', 'deal', 'recall', 'visit_and_meetings',],
	project_id: null
  };
  